import React from 'react'
import List from './List'
import { usePositionRatesById } from 'src/queries'

interface BodyProps {
  id: number
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const position = usePositionRatesById(id)
  return (
    <List position={position} />
  )
}

export default Body
